import React, { useEffect, useState } from "react";
import "../../App.css";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { Link } from "react-router-dom";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMapEvents,
} from "react-leaflet";
import L from "leaflet";
import plusicon from "../../img/plusIcon.png";
import yellowPlusIcon from "../../img/Plus-Icon-Yellow-Circle.png";
import ChangeView from "./ChangeView";
import Continent from "./Continent";
import Search from "./Search";
import { useRef } from "react";
import { baseURL } from "../../components/BaseURL";
import SearchV3 from "./SearchV3";

function MyComponent({ handleZoomLevel }) {
  const [zoomLevel, setZoomLevel] = useState(2); // initial zoom level provided for MapContainer

  const mapEvents = useMapEvents({
    zoomend: () => {
      setZoomLevel(mapEvents.getZoom());
    },
  });

  handleZoomLevel(zoomLevel);

  return null;
}
/*
export const getUserLocation = () => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
            //console.log(position);
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            //console.log(lat, lng);
            const userLocation = { lat, lng };
            //console.log(userLocation);
            return userLocation;
        });
    } else {
        console.log("Geolocation is not supported by this browser.");
    }
};
*/

const Remote = () => {
  const [allCountries, setAllCountries] = useState([]);
  const [allContinents, setAllContinents] = useState([]);
  const [zoomLevel, setZoomLevel] = useState(2); // initial zoom level provided for MapContainer
  const [center, setCenter] = useState([27, 30]);
  const [mouseOverPopupContainer, setMouseOverPopupContainer] = useState(false);
  const getLocationOnce = useRef(false);
  const [adsRegion, setAdsRegion] = useState([]);

  // ask location permission from user

  useEffect(() => {
    if (!getLocationOnce.current) {
      getLocationOnce.current = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            //console.log(position);
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            //console.log(lat, lng);
            //const userLocation = { lat, lng };
            //console.log(userLocation);
            setCenter([lat, lng]);
            setZoomLevel(5);
          },
          (error) => {
            console.log(error);
            alert(
              "Turn on your device location services to get better experience"
            );
          }
        );
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    }
  }, []);

  /*React.useEffect(() => {
        // set user ip
        fetch('https://geolocation-db.com/json/')
            .then(res => res.json())
            .then(data => {
                setCenter([data.latitude, data.longitude]);
                setZoomLevel(5);
            })
    }, []);*/

  const markerIcon = L.icon({
    iconUrl: yellowPlusIcon,
    iconSize: [20, 20],
  });

  useEffect(() => {
    fetch(`${baseURL}/project-main/get-all-areas`)
      .then((res) => res.json())
      .then((data) => {
        setAllCountries(data);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    fetch(`${baseURL}/project-main/get-all-continents`)
      .then((res) => res.json())
      .then((data) => {
        setAllContinents(data);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleZoomLevel = (zoom) => {
    setZoomLevel(zoom);
  };

  const changeCenter = (lat, long) => {
    setZoomLevel(zoomLevel + 2);
    setCenter([lat, long]);
  };

  // HIDE and SEE states

  const [hideCountry, setHideCountry] = useState(true);
  const [hideArea, setHideArea] = useState(true);
  const [hideCity, setHideCity] = useState(true);

  const [countryId, setCountryId] = useState(null);
  const [areaId, setAreaId] = useState(null);
  const [cityId, setCityId] = useState(null);

  const toogleHideCountry = (id) => {
    setHideCountry(!hideCountry);
    setCountryId(id);
  };

  const toogleHideArea = () => {
    setHideArea(!hideArea);
  };

  const toogleHideCity = () => {
    setHideCity(!hideCity);
  };

  return (
    <div>
      <div className="flex justify-center items-center h-[400px] ">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-pink-500 mb-4 animate-pulse">
            Your link to remote control the equipments will appear here.
          </h1>
          <p className="text-white">
            Please check your email for instructions
          </p>
        </div>
      </div>
    </div>
  );
};

export default Remote;
